<template>
  <tr class="bcl-token-list-table-row token-row-skeleton rounded">
    <td class="cell cell-rank pl-2 pl-md-4">
      <v-skeleton-loader type="text" class="rank" />
    </td>
    <td class="cell cell-name px-1 px-md-3">
      <v-skeleton-loader type="text" class="token-name" />
    </td>
    <td class="cell cell-price px-1 px-md-3">
      <div class="flex-container">
        <v-skeleton-loader type="text" class="price-value" />
      </div>
    </td>
    <td class="cell cell-market-cap px-1 px-md-3 text-md-right">
      <div class="flex-container">
        <v-skeleton-loader type="text" class="market-cap-value" />
      </div>
    </td>
    <td class="cell cell-address text-right px-1 px-md-3">
      <v-skeleton-loader type="text" class="address-chip" />
    </td>
    <td class="cell cell-chart text-right pr-md-4">
      <div class="flex-container">
        <div class="chart">
          <svg
            width="139"
            height="35"
            viewBox="0 0 139 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="chart-svg"
          >
            <path
              d="M1 28L38.5 11.5L80 33L138 2"
              stroke="currentColor"
              stroke-width="3"
            />
          </svg>
        </div>
      </div>
    </td>
    <td class="cell cell-link"></td>
  </tr>
</template>

<style lang="scss" scoped>
@use "@/styles/variables" as *;

.token-row-skeleton {
  opacity: 0.5;
  height: 60px;

  .cell {
    &-market-cap,
    &-price,
    &-chart {
      .flex-container {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }

  .rank {
    ::v-deep .v-skeleton-loader__bone {
      width: 16px;
      height: 16px;
      margin: 0;
    }
  }

  .token-name,
  .collection-label,
  .price-value,
  .market-cap-value,
  .address-chip {
    width: 100%;
    ::v-deep .v-skeleton-loader__bone {
      height: 16px;
      margin: 0;
    }
  }

  .chart {
    height: 100%;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chart-svg {
    color: rgba(255, 255, 255, 0.12);
    opacity: 0.5;
  }

  @media screen and (max-width: 960px) {
    display: grid;
    grid-template-columns: 32px 5fr 2fr;
    grid-template-rows: 1fr 20px 20px;
    grid-template-areas:
      "rank name       chart"
      "rank price      chart"
      "rank market-cap chart";
    margin-top: 4px;
    padding-block: 8px;
    height: 80px;

    .cell {
      display: block;
      &-collection,
      &-address {
        display: none;
      }
      &-price,
      &-market-cap {
        .flex-container {
          justify-content: flex-start;
          align-items: center;
        }
      }

      &-rank {
        padding-top: 3px;
        font-size: 12px;
        font-family: $body-font-family;
        display: flex;
        align-items: center;
      }
    }

    .token-name {
      width: 200px;
    }

    .price-value,
    .market-cap-value {
      width: 200px;
      ::v-deep .v-skeleton-loader__bone {
        height: 12px;
      }
    }

    .chart {
      align-items: center;
      margin: 0;
      width: 2000px;

      .chart-svg {
        transform: scale(0.8);
      }
    }
  }
}
</style>
<script setup lang="ts"></script>
